'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var styles = function styles() {
  return {
    message: {
      textAlign: 'center',
      marginBottom: '30px'
    },
    logoImage: {
      maxHeight: '50px',
      maxWidth: '300px',
      margin: '0',
      padding: '0'
    }
  };
};

exports.default = styles;